.userInfo {
  position: relative;
  flex: 1;
  cursor: pointer;
  font-family: var(--f-sans-serif);
  background-color: transparent;
}

.userInfo .navRoot:hover {
  opacity: 0.75;
  text-decoration: underline;
}

.userInfo .userInfoLoginHamburger {
  font-size: 0.9rem;
}

.userInfo .userInfoPanel {
  display: block;
  width: 100%;
  padding: 0 8px;
  box-shadow: inset 0 0 20px 0 rgb(0 0 0 / 15%);
  text-align: center;
  border-radius: 8px;
  background-color: white;
  z-index: 10;
  box-sizing: border-box;
  @media (min-width: 768px) {
    padding: 0px 15px !important;
    position: absolute;
    left: 0;
    top: 30px;
    list-style: none;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    border: 0;
    min-width: 160px;
    width: max-content;
  }
}

.userInfo .userInfoPanel .userInfoLoginId {
  color: rgb(177, 4, 66);
  font-size: 0.8rem;
}

.userInfo .userInfoPanel > li,
.userInfo .userInfoPanel > li > a {
  font-family: "Mukta Malar", sans-serif;
  font-size: 14px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.79;
  letter-spacing: normal;
  color: #333;
}

.dropdownToggle::after {
  display: inline-block;
  margin-left: 0.255em;
  content: "";
  border-right: 0.3em solid transparent;
  border-left: 0.3em solid transparent;
  color: #b00141;
  vertical-align: middle;
  border-top: 0.3em solid;
  border-bottom: 0;
}

.open {
  rotate: 180deg;
}

.mySPHLine {
  opacity: 0.3;
  border: 0.65px solid #000;
}
